<editor #editor apiKey="vvv9v8z1vcfmn95296libwzygdro9epslodsru344hy9pe58" [init]="editorConfig" [class.editor-invalid]="invalid"></editor>
